// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ScheduleGrid\UpdateResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthClosure, BerthClosureData, BerthClosureOptions } from 'data/models/BerthClosure';
import { BerthReservation, BerthReservationData, BerthReservationOptions } from 'data/models/BerthReservation';
import { ItineraryPoint, ItineraryPointData, ItineraryPointOptions } from 'data/models/ItineraryPoint';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { UnlistedBerthReservation, UnlistedBerthReservationData, UnlistedBerthReservationOptions } from 'data/models/UnlistedBerthReservation';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';
import { BerthClosureRights, PortCallRights } from 'server/enums/Rights';

// ScheduleGridUpdateResponseData is the class that ScheduleGridUpdateResponse serializes to/from
export interface ScheduleGridUpdateResponseData {
	
    BerthClosures : BerthClosureData[] | null;
    BerthReservations : BerthReservationData[] | null;
    ItineraryPoints : ItineraryPointData[] | null;
    PortCalls : PortCallData[] | null;
    UnlistedReservations : UnlistedBerthReservationData[] | null;
    Vessels : VesselData[] | null;
	
    BerthClosureRights : { [key: number]: BerthClosureRights; };
    PortCallRights : { [key: number]: PortCallRights; };
}

// ScheduleGridUpdateResponseOptions is the class which may be passed to the ScheduleGridUpdateResponse constructor to define optional initial data values
export interface ScheduleGridUpdateResponseOptions {
	
    BerthClosures? : BerthClosureOptions[] | null;
    BerthReservations? : BerthReservationOptions[] | null;
    ItineraryPoints? : ItineraryPointOptions[] | null;
    PortCalls? : PortCallOptions[] | null;
    UnlistedReservations? : UnlistedBerthReservationOptions[] | null;
    Vessels? : VesselOptions[] | null;
	
    BerthClosureRights? : { [key: number]: BerthClosureRights; };
    PortCallRights? : { [key: number]: PortCallRights; };
}

export class ScheduleGridUpdateResponse {
	
    public BerthClosures : SDataArray<BerthClosure>;
    public BerthReservations : SDataArray<BerthReservation>;
    public ItineraryPoints : SDataArray<ItineraryPoint>;
    public PortCalls : SDataArray<PortCall>;
    public UnlistedReservations : SDataArray<UnlistedBerthReservation>;
    public Vessels : SDataArray<Vessel>;
	
    public BerthClosureRights : DataSignal<{ [key: number]: BerthClosureRights; }>;
    public PortCallRights : DataSignal<{ [key: number]: PortCallRights; }>;

    constructor();
    constructor(data : ScheduleGridUpdateResponseOptions);
    constructor(data: ScheduleGridUpdateResponseOptions | null = null) {
	    
        this.BerthClosures = SArray<BerthClosure>([]);
        this.BerthReservations = SArray<BerthReservation>([]);
        this.ItineraryPoints = SArray<ItineraryPoint>([]);
        this.PortCalls = SArray<PortCall>([]);
        this.UnlistedReservations = SArray<UnlistedBerthReservation>([]);
        this.Vessels = SArray<Vessel>([]);
	    
        this.BerthClosureRights = jsonableObservable(S.value<{ [key: number]: BerthClosureRights; }>(data && data.BerthClosureRights !== undefined ? data.BerthClosureRights : {}));
        this.PortCallRights = jsonableObservable(S.value<{ [key: number]: PortCallRights; }>(data && data.PortCallRights !== undefined ? data.PortCallRights : {}));
    }

    static key(obj : ScheduleGridUpdateResponse) {
        return ;
    }
    
    static dataKey(obj : ScheduleGridUpdateResponseOptions) {
        return ;
    }

    static update(obj : ScheduleGridUpdateResponse, data : ScheduleGridUpdateResponseOptions) {
        S.freeze(() => {
	        
	        
            if (data.BerthClosureRights !== undefined) obj.BerthClosureRights(data.BerthClosureRights);
            if (data.PortCallRights !== undefined) obj.PortCallRights(data.PortCallRights);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ScheduleGridUpdateResponse.ts